import PropTypes from 'prop-types';

let _next_id = 0;

export const getId = function(type) {
  _next_id = _next_id + 1;
  return `_${type}${_next_id}`;
};

const DateStringType = PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]);

export const TicketClassShape = PropTypes.shape({
  active: PropTypes.bool,
  availability_finish: DateStringType,
  availability_start: DateStringType,
  created_at: DateStringType,
  created_by: PropTypes.number,
  currency: PropTypes.string,
  customer_pays_fees: PropTypes.bool,
  deleted_at: DateStringType,
  deleted_by: PropTypes.number,
  description: PropTypes.string,
  donation: PropTypes.bool,
  event_id: PropTypes.number,
  hidden: PropTypes.bool,
  id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
  max_price: PropTypes.number,
  min_price: PropTypes.number,
  name: PropTypes.string,
  payout_account_id: PropTypes.number,
  platform_id: PropTypes.number,
  position: PropTypes.number,
  price: PropTypes.number,
  purchase_limit: PropTypes.number,
  purchase_minimum: PropTypes.number,
  quantity_limit: PropTypes.number,
  refunds_allowed: PropTypes.bool,
  ticket_group_id: PropTypes.number,
  updated_at: DateStringType,
  updated_by: PropTypes.number,
  promo_code_ids: PropTypes.arrayOf(PropTypes.number),
  create: PropTypes.bool,
  delete: PropTypes.bool,
  ticket_type: PropTypes.oneOf(["in_person", "virtual", "wait_list"]),
  virtual_event_message: PropTypes.string,
  virtual_event_url: PropTypes.string
});

export const TicketGroupShape = PropTypes.shape({
  id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
  name: PropTypes.string,
  position: PropTypes.number,
  create: PropTypes.bool,
  delete: PropTypes.bool
});

export const PromoCodeShape = PropTypes.shape({
  active: PropTypes.bool,
  amount: PropTypes.number,
  code: PropTypes.string,
  created_at: DateStringType,
  created_by: PropTypes.number,
  deleted_at: DateStringType,
  deleted_by: PropTypes.number,
  discount_type: PropTypes.string,
  event_id: PropTypes.number,
  id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
  percent: PropTypes.number,
  response_type: PropTypes.string,
  usage_limit: PropTypes.number,
  total_usage: PropTypes.number,
  updated_at: DateStringType,
  updated_by: PropTypes.number,
  create: PropTypes.bool,
  delete: PropTypes.bool
});

export const AttendeeQuestionShape = PropTypes.shape({
  active: PropTypes.bool,
  created_at: DateStringType,
  created_by: PropTypes.number,
  deleted_at: DateStringType,
  deleted_by: PropTypes.number,
  event_id: PropTypes.number,
  id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
  position: PropTypes.number,
  question: PropTypes.string,
  required: PropTypes.bool,
  response_type: PropTypes.string,
  updated_at: DateStringType,
  updated_by: PropTypes.number,
  create: PropTypes.bool,
  delete: PropTypes.bool
});

const createAction = function(name) {
  return function(payload, extra) {
    if (extra == null) { extra = {}; }
    return _.assign({type: name, payload}, extra);
  };
};

export const SET_TICKET_CLASSES_GROUPS_ATTENDEE_QUESTIONS_PROMOS = 'SET_TICKET_CLASSES_GROUPS_ATTENDEE_QUESTIONS_PROMOS';
export const setTicketClassesGroupsAttendeeQuestionsPromos = createAction('SET_TICKET_CLASSES_GROUPS_ATTENDEE_QUESTIONS_PROMOS');

export const EVENT_EXPERIENCE_CHANGE = 'EVENT_EXPERIENCE_CHANGE';
export const eventExperienceChange = createAction('EVENT_EXPERIENCE_CHANGE');
export const EVENT_STREAM_URL_CHANGE = 'EVENT_STREAM_URL_CHANGE';
export const eventStreamUrlChange = createAction('EVENT_STREAM_URL_CHANGE');
export const EVENT_PAYOUT_ACCOUNT_ID_CHANGE = 'EVENT_PAYOUT_ACCOUNT_ID_CHANGE';
export const eventPayoutAccountIdChange = createAction('EVENT_PAYOUT_ACCOUNT_ID_CHANGE');
export const EVENT_HAS_ADDRESS_CHANGE = 'EVENT_HAS_ADDRESS_CHANGE';
export const eventHasAddressChange = createAction('EVENT_HAS_ADDRESS_CHANGE');

export const TICKET_CLASS_ADD = 'TICKET_CLASS_ADD';
export const addTicketClass = function(payload, extra) {
  if (extra == null) { extra = {}; }
  const next_id = getId('ticket');
  return _.assign({type: 'TICKET_CLASS_ADD', payload: {id: next_id}}, extra);
};

export const TICKET_CLASS_REMOVE = 'TICKET_CLASS_REMOVE';
export const removeTicketClass = createAction('TICKET_CLASS_REMOVE');
export const TICKET_CLASS_CHANGE = 'TICKET_CLASS_CHANGE';
export const changeTicketClass = createAction('TICKET_CLASS_CHANGE');
export const TICKET_CLASS_DRAG_START = 'TICKET_CLASS_DRAG_START';
export const ticketClassDragStart = createAction('TICKET_CLASS_DRAG_START');
export const TICKET_CLASS_DRAG_FINISH = 'TICKET_CLASS_DRAG_FINISH';
export const ticketClassDragFinish = createAction('TICKET_CLASS_DRAG_FINISH');
export const TICKET_CLASS_DRAG_CANCEL = 'TICKET_CLASS_DRAG_CANCEL';
export const ticketClassDragCancel = createAction('TICKET_CLASS_DRAG_CANCEL');
export const TICKET_CLASS_DRAG_UPDATE = 'TICKET_CLASS_DRAG_UPDATE';
export const ticketClassDragUpdate = createAction('TICKET_CLASS_DRAG_UPDATE');

export const TICKET_GROUP_ADD = 'TICKET_GROUP_ADD';
export const addTicketGroup = function(payload, extra) {
  if (extra == null) { extra = {}; }
  const next_id = getId('ticket_group');
  return _.assign({type: 'TICKET_GROUP_ADD', payload: {id: next_id}}, extra);
};

export const TICKET_GROUP_REMOVE = 'TICKET_GROUP_REMOVE';
export const removeTicketGroup = createAction('TICKET_GROUP_REMOVE');
export const TICKET_GROUP_CHANGE = 'TICKET_GROUP_CHANGE';
export const changeTicketGroup = createAction('TICKET_GROUP_CHANGE');
export const TICKET_GROUP_DRAG_START = 'TICKET_GROUP_DRAG_START';
export const ticketGroupDragStart = createAction('TICKET_GROUP_DRAG_START');
export const TICKET_GROUP_DRAG_FINISH = 'TICKET_GROUP_DRAG_FINISH';
export const ticketGroupDragFinish = createAction('TICKET_GROUP_DRAG_FINISH');
export const TICKET_GROUP_DRAG_CANCEL = 'TICKET_GROUP_DRAG_CANCEL';
export const ticketGroupDragCancel = createAction('TICKET_GROUP_DRAG_CANCEL');
export const TICKET_GROUP_DRAG_UPDATE = 'TICKET_GROUP_DRAG_UPDATE';
export const ticketGroupDragUpdate = createAction('TICKET_GROUP_DRAG_UPDATE');

export const PROMO_CODE_ADD = 'PROMO_CODE_ADD';
export const addPromoCode = function(payload, extra) {
  if (extra == null) { extra = {}; }
  const next_id = getId('promo_code');
  return _.assign({type: 'PROMO_CODE_ADD', payload: {id: next_id}}, extra);
};

export const PROMO_CODE_REMOVE = 'PROMO_CODE_REMOVE';
export const removePromoCode = createAction('PROMO_CODE_REMOVE');
export const PROMO_CODE_CHANGE = 'PROMO_CODE_CHANGE';
export const changePromoCode = createAction('PROMO_CODE_CHANGE');
export const PROMO_CODE_TICKET_CLASS_ADD = 'PROMO_CODE_TICKET_CLASS_ADD';
export const promoCodeAddTicketClass = createAction('PROMO_CODE_TICKET_CLASS_ADD');
export const PROMO_CODE_TICKET_CLASS_REMOVE = 'PROMO_CODE_TICKET_CLASS_REMOVE';
export const promoCodeRemoveTicketClass = createAction('PROMO_CODE_TICKET_CLASS_REMOVE');

export const ATTENDEE_QUESTION_ADD = 'ATTENDEE_QUESTION_ADD';
export const addAttendeeQuestion = function(payload, extra) {
  if (extra == null) { extra = {}; }
  const next_id = getId('question');
  return _.assign({type: 'ATTENDEE_QUESTION_ADD', payload: {id: next_id}}, extra);
};

export const ATTENDEE_QUESTION_REMOVE = 'ATTENDEE_QUESTION_REMOVE';
export const removeAttendeeQuestion = createAction('ATTENDEE_QUESTION_REMOVE');
export const ATTENDEE_QUESTION_CHANGE = 'ATTENDEE_QUESTION_CHANGE';
export const changeAttendeeQuestion = createAction('ATTENDEE_QUESTION_CHANGE');
export const ATTENDEE_QUESTION_DRAG_START = 'ATTENDEE_QUESTION_DRAG_START';
export const attendeeQuestionDragStart = createAction('ATTENDEE_QUESTION_DRAG_START');
export const ATTENDEE_QUESTION_DRAG_FINISH = 'ATTENDEE_QUESTION_DRAG_FINISH';
export const attendeeQuestionDragFinish = createAction('ATTENDEE_QUESTION_DRAG_FINISH');
export const ATTENDEE_QUESTION_DRAG_CANCEL = 'ATTENDEE_QUESTION_DRAG_CANCEL';
export const attendeeQuestionDragCancel = createAction('ATTENDEE_QUESTION_DRAG_CANCEL');
export const ATTENDEE_QUESTION_DRAG_UPDATE = 'ATTENDEE_QUESTION_DRAG_UPDATE';
export const attendeeQuestionDragUpdate = createAction('ATTENDEE_QUESTION_DRAG_UPDATE');

export const ATTENDEE_QUESTION_CHOICE_ADD = 'ATTENDEE_QUESTION_CHOICE_ADD';
export const addAttendeeQuestionChoice = createAction('ATTENDEE_QUESTION_CHOICE_ADD');
export const ATTENDEE_QUESTION_CHOICE_CHANGE = 'ATTENDEE_QUESTION_CHOICE_CHANGE';
export const changeAttendeeQuestionChoice = createAction('ATTENDEE_QUESTION_CHOICE_CHANGE');
export const ATTENDEE_QUESTION_CHOICE_REMOVE = 'ATTENDEE_QUESTION_CHOICE_REMOVE';
export const removeAttendeeQuestionChoice = createAction('ATTENDEE_QUESTION_CHOICE_REMOVE');
export const ATTENDEE_QUESTION_CHOICE_DRAG_START = 'ATTENDEE_QUESTION_CHOICE_DRAG_START';
export const attendeeQuestionChoiceDragStart = createAction('ATTENDEE_QUESTION_CHOICE_DRAG_START');
export const ATTENDEE_QUESTION_CHOICE_DRAG_UPDATE = 'ATTENDEE_QUESTION_CHOICE_DRAG_UPDATE';
export const attendeeQuestionChoiceDragUpdate = createAction('ATTENDEE_QUESTION_CHOICE_DRAG_UPDATE');
export const ATTENDEE_QUESTION_CHOICE_DRAG_FINISH = 'ATTENDEE_QUESTION_CHOICE_DRAG_FINISH';
export const attendeeQuestionChoiceDragFinish = createAction('ATTENDEE_QUESTION_CHOICE_DRAG_FINISH');
export const ATTENDEE_QUESTION_CHOICE_DRAG_CANCEL = 'ATTENDEE_QUESTION_CHOICE_DRAG_CANCEL';
export const attendeeQuestionChoiceDragCancel = createAction('ATTENDEE_QUESTION_CHOICE_DRAG_CANCEL');
